import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Float from './Float';

const Main = () => {
  return (
    <div className="w-full relative bg-secondary">
       <Float />
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Main;
